export default __webpack_public_path__ + "static/media/main-characters-end-sm-2x.f5958dfd.jpg";